/* unplugin-vue-components disabled */import { render } from "./templateInit.vue?vue&type=template&id=7764fd4c"
import script from "./templateInit.vue?vue&type=script&lang=js"
export * from "./templateInit.vue?vue&type=script&lang=js"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__